import columns from '../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import { sumTotal, totalRowRatio } from '../../../../../react-table/helpers/rowTotals';

export function getDetailsTabNavOptions(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.THRESHOLDS_FOR_CERTIFICATION_545_DETAILS.id,
    mainReportId: ReportDefinitions.THRESHOLDS_FOR_CERTIFICATION_545_SUMMARY.id,
    requestParams: {
      impc: rowInfo.row['impc.impcTo'],
      product: rowInfo.row['impc.product'],
      transportMode: rowInfo.row['impc.transportMode'],
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export const percentagePredesResdesConditionalProps = key => (state, rowInfo) => {
  let className = '';
  const pctResdesVPredes = `ratio.${key}`;
  if (rowInfo) {
    const { row } = rowInfo;
    if (row) {
      className = 'text-grey';
      if (row[pctResdesVPredes] < 92) {
        className = 'text-red';
      }
      if (row[pctResdesVPredes] >= 92 && row[pctResdesVPredes] < 97) {
        className = 'text-orange';
      }
    }
  }
  return {
    className,
  };
};

export const percentageResconPreconConditionalProps = key => (state, rowInfo) => {
  let className = '';
  const pctResconVPrecon = `ratio.${key}`;
  if (rowInfo) {
    const { row } = rowInfo;
    if (row) {
      className = 'text-grey';
      if (row[pctResconVPrecon] < 90) {
        className = 'text-red';
      }
      if (row[pctResconVPrecon] >= 90 && row[pctResconVPrecon] < 95) {
        className = 'text-orange';
      }
    }
  }
  return {
    className,
  };
};

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    PercentageColumn,
    NavigationWithFooterColumn,
  } = columns(data);

  return [
    {
      Header: 'IMPC',
      columns: [
        new TextColumn('Destination', 'impc.impcTo').withTotalHeader('Total'),
      ],
    },
    {
      Header: '',
      columns: [
        new TextColumn('Last leg transport mode', 'impc.transportMode'),
        new TextColumn('Product', 'impc.product'),
      ],
    },
    {
      Header: 'Receptacles',
      columns: [
        new NavigationWithFooterColumn(new NonZeroNumberColumn('PREDES', 'receptacles.predes').withTotalHeader(sumTotal), getDetailsTabNavOptions),
        new NonZeroNumberColumn('RESDES vs PREDES', 'receptacles.resdesVPredes').withTotalHeader(sumTotal),
        new NonZeroNumberColumn('PRECON vs PREDES\n' +
          '(received by dest DO) (1)', 'receptacles.preconVPredes').withTotalHeader(sumTotal),
        new NonZeroNumberColumn('RESCON vs PRECON', 'receptacles.resconVPrecon').withTotalHeader(sumTotal),
        new NonZeroNumberColumn('CARDIT vs PREDES (2)', 'receptacles.carditVPRedes').withTotalHeader(sumTotal),
      ],
      drillDownLink: {
        reportId: ReportDefinitions.THRESHOLDS_FOR_CERTIFICATION_545_DETAILS.id,
        mainReportId: ReportDefinitions.THRESHOLDS_FOR_CERTIFICATION_545_SUMMARY.id,
        requestParams: {
          impc: '',
          product: '',
          transportMode: '',
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      },
    },
    {
      Header: 'Ratio %',
      columns: [
        new PercentageColumn('RESDES vs PREDES\n' +
          '(threshold: 97%)', 'ratio.pctResdesVPredes').withGetProps(percentagePredesResdesConditionalProps('pctResdesVPredes')).withTotalHeader(totalRowRatio(['receptacles.resdesVPredes', 'receptacles.predes'])),
        new PercentageColumn('RESCON vs PRECON\n' +
          '(threshold: 95%)', 'ratio.pctResconVPrecon').withGetProps(percentageResconPreconConditionalProps('pctResconVPrecon')).withTotalHeader(totalRowRatio(['receptacles.resconVPrecon', 'receptacles.preconVPredes'])),
        new PercentageColumn('CARDIT vs PREDES (for info)', 'ratio.pctCarditVPredes').withTotalHeader(totalRowRatio(['receptacles.carditVPRedes', 'receptacles.predes'])),
      ],
    },
  ];
};
